<template>
  <div>
    <list-layout
      :can-operate="canOperate"
      :column-default-selected="columnDefaultSelected"
      :columns-all="columnsAll"
      :default-selected="tableDefaultSelectData"
      :export-func="exportFunc"
      :get-table-data-func="getTableDataFunc"
      :group-tree-func="groupTreeFunc"
      :in-modal="inModal"
      :refresh="updateTableFlag"
      :route-params="$route.params"
      :table-operation-width="tableOperationWidth"
      :tools-list="toolsList"
      @tableSelectData="getSelectData"
      :apiPermission="groupApiPermission"
      :can-drag-column-width="true"
    >
      <template #leftTool>
        <create-button v-permission="{action: 'base.office_equipment.create', effect: 'disabled'}" @click="$refs.inputDrawer.show()">
        </create-button>
      </template>
      <!-- 表格自定义列 -->
      <template #name="{ slotProps }">
        <a-tooltip placement="topLeft" :title="slotProps.text">
          {{ slotProps.text }}
        </a-tooltip>
      </template>
      <template #operation="{ slotProps }">
        <edit-button
          v-permission="{action: 'base.office_equipment.update', effect: 'disabled'}"
          @click="$refs.inputDrawer.show(slotProps.record.id)"
        ></edit-button>
        <delete-button v-permission="{action: 'base.office_equipment.delete', effect: 'disabled'}" @confirm="confirm(slotProps.record.id)"></delete-button>
      </template>
    </list-layout>

    <input-drawer ref="inputDrawer" @ok="confirm"></input-drawer>
  </div>
</template>

<script>
import moment from 'moment'
import {
  createOfficeEquipmentGroup,
  deleteOfficeEquipment,
  deleteOfficeEquipmentGroup,
  exportOfficeEquipment,
  getOfficeEquipmentGroup,
  getOfficeEquipmentGroupList,
  getOfficeEquipmentList,
  updateOfficeEquipmentGroup
} from '@/api/office-equipment'
import ListLayout from '@/components/ListLayout.vue'
import DeleteButton from '@/components/button/DeleteButton'
import EditButton from '@/components/button/EditButton'
import CreateButton from '@/components/button/CreateButton'
import { hasPermission } from '@/utils'

export default {
  name: 'OfficeEquipmentTable',
  components: {
    DeleteButton,
    EditButton,
    CreateButton,
    InputDrawer: () => import('./modules/InputDrawer.vue'),
    ListLayout
  },
  props: {
    defaultSelected: {
      type: Array
    },
    toolsList: {
      type: Array,
      default: () => []
    },
    tableOperationWidth: {
      type: Number,
      default: 240
    },
    link: {
      type: Boolean,
      default: true
    },
    refresh: {
      type: Boolean
    },
    canOperate: {
      type: Boolean,
      default: true
    },
    inModal: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      getTableDataFunc: getOfficeEquipmentList,
      exportFunc: exportOfficeEquipment,
      columnsAll: [
        {
          dataIndex: 'name',
          title: '名称',
          fixed: 'left',
          width: 160
        },
        {
          dataIndex: 'vendor',
          title: '厂商',
          width: 160
        },
        {
          dataIndex: 'model',
          title: '型号',
          width: 160
        },
        {
          dataIndex: 'cpu',
          title: 'CPU',
          width: 160
        },
        {
          dataIndex: 'memory',
          title: '内存',
          width: 160
        },
        {
          dataIndex: 'disk',
          title: '存储',
          width: 160
        },
        {
          dataIndex: 'os_type',
          title: '操作系统类型',
          width: 160
        },
        {
          dataIndex: 'os_name',
          title: '操作系统名称',
          width: 160
        },
        {
          dataIndex: 'location',
          title: '位置',
          width: 160
        },
        {
          dataIndex: 'sn',
          title: '资产编号',
          width: 160
        },
        {
          dataIndex: 'ip_address',
          title: 'IP 地址',
          width: 160
        },
        {
          dataIndex: 'applicant',
          title: '申请人',
          width: 160
        },
        {
          dataIndex: 'applied_at',
          title: '申请时间',
          width: 200
        },
        {
          dataIndex: 'office',
          title: '处室',
          width: 160
        },
        {
          dataIndex: 'usage',
          title: '用途',
          width: 200
        },
        {
          dataIndex: 'service',
          title: '所属业务',
          width: 160
        }
      ],
      columnDefaultSelected: [
        'name',
        'vendor',
        'model',
        'sn',
        'ip_address',
        'applicant',
        'usage'
      ],
      updateTableFlag: this.refresh,
      tableSelectData: [],
      tableDefaultSelectData: [],
      groupApiPermission: {
        create: 'base.office_equipment_group.create',
        edit: 'base.office_equipment_group.update',
        delete: 'base.office_equipment_group.delete'
      }
    }
  },
  computed: {
    groupTreeFunc () {
      if (hasPermission(['base.office_equipment_group.view'])) {
        return {
          createFunc: createOfficeEquipmentGroup,
          deleteFunc: deleteOfficeEquipmentGroup,
          getFunc: getOfficeEquipmentGroup,
          getListFunc: getOfficeEquipmentGroupList,
          updateFunc: updateOfficeEquipmentGroup
        }
      } else return null
    }
  },
  mounted () {
    if (this.defaultSelected) this.tableDefaultSelectData = this.defaultSelected
  },
  methods: {
    isValid (expiresAt) {
      return moment.now() < moment(expiresAt, 'YYYY-MM-DD HH:mm:ss')
    },
    getSelectData (data) {
      this.tableSelectData = data
      this.$emit('selectedData', data)
    },
    async confirm (id = '') {
      if (id) {
        await deleteOfficeEquipment(id).then(res => {
          this.$message.success(res.message)
        })
        this.tableSelectData.splice(this.tableSelectData.findIndex(item => item.key === id), 1)
        this.tableDefaultSelectData = this.tableSelectData
        this.$emit('selectedData', this.tableSelectData)
      }
      this.updateTableFlag = !this.updateTableFlag
    }
  },
  watch: {
    refresh (v) {
      this.updateTableFlag = v
    }
  }
}
</script>
